export default "__VITE_ASSET__D5883CAA__"